// for reference: https://stackoverflow.com/questions/37482366/is-it-safe-to-expose-firebase-apikey-to-the-public#37484053
const config = {
  apiKey: "AIzaSyBEva3aT_YmbZ7xV9I8QGs4KqBdWvOPJD4",
  authDomain: "n2n-inventory-prod.firebaseapp.com",
  projectId: "n2n-inventory-prod",
  storageBucket: "n2n-inventory-prod.appspot.com",
  messagingSenderId: "764646938784",
  appId: "1:764646938784:web:d0a8ad75e3cc9a273311c5",
  measurementId: "G-DV6GKHD0KC",
};

export default config;
